import { Reducer } from 'redux';
import {
    ADD_AUDIO_IN_GROUP,
    ADD_GROUP,
    IAddAudioInGroup,
    IModelsActions,
    IModelsState, IMoveAudioToGroup,
    IRefreshCallGroupAction,
    IRemoveAudioFromGroup,
    IUpdateAudioAction,
    MOVE_AUDIO_TO_GROUP,
    REFRESH_CALL_GROUP,
    REMOVE_AUDIO_FROM_GROUP,
    REMOVE_GROUP,
    RESET_MODELS_ACTION,
    SET_ACTIVE_GROUP,
    SET_GROUPS,
    SET_GROUPS_LOADED,
    SET_LANGS_ACTION,
    SET_LANGUAGES,
    SET_USER_ROLES_ACTION,
    TAudio,
    TUserGroup,
    UPDATE_AUDIO,
} from './types';

const initialState: IModelsState = {
    groups: [],
    groupsLoaded: false,
    languages: [],
    activeGroupId: null,
    langs: [],
    userRoles: []
};

export const modelsReducer: Reducer<IModelsState, IModelsActions> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case SET_GROUPS:
            return {
                ...state,
                groups: action.groups
            };
        case SET_GROUPS_LOADED:
            return {
                ...state,
                groupsLoaded: action.groupsLoaded
            };
        case SET_LANGUAGES:
            return {
                ...state,
                languages: action.languages
            };
        case SET_ACTIVE_GROUP:
            return {
                ...state,
                activeGroupId: action.activeGroupId ? +action.activeGroupId : null
            };
        case ADD_GROUP:
            return {
                ...state,
                groups: [
                    ...state.groups,
                    action.group
                ]
            };
        case REMOVE_GROUP:
            const groups = state.groups.filter(group => group.id !== action.groupId);
            return {
                ...state,
                groups
            };
        case REFRESH_CALL_GROUP:
            return refreshCallGroup(state, action);
        case ADD_AUDIO_IN_GROUP:
            return addAudioInGroup(state, action);
        case UPDATE_AUDIO:
            return updateAudio(state, action);
        case REMOVE_AUDIO_FROM_GROUP:
            return removeAudioFromGroup(state, action);
        case MOVE_AUDIO_TO_GROUP:
            return {
                ...state,
                ...moveAudioToGroup(state, action)
            }
        case SET_LANGS_ACTION:
            return {...state, langs: [...action.langs]}
        case SET_USER_ROLES_ACTION:
            return {...state, userRoles: [...action.userRoles]}
        case RESET_MODELS_ACTION:
            return {...initialState}
        default:
            return state;
    }
};

const moveAudioToGroup = (state: IModelsState, action: IMoveAudioToGroup): IModelsState => {
    if (action.fromGroupId === action.toGroupId)
        return {...state};
    const groups: TUserGroup[] = [...state.groups];
    const fromGroup = groups.find(g => g.id === action.fromGroupId);
    const toGroup = groups.find(g => g.id === action.toGroupId);
    if (!fromGroup || !toGroup)
        return {...state};
    const audio = fromGroup.audios.find(a => a.id === action.audioId);
    if (!audio)
        return {...state};

    fromGroup.audios = fromGroup.audios.filter((audio) => {
        return audio.id !== action.audioId;
    })
    toGroup.audios = [audio, ...toGroup.audios];
    return {
        ...state,
        groups
    }
}

// refresh new audio with real url, s3FilePath, etc
const refreshCallGroup = (state: IModelsState, action: IRefreshCallGroupAction): IModelsState => {
    const index = state.groups.findIndex(g => g.id === action.group.id);
    if (index < 0) return state;
    const prev = state.groups[index];
    const groups: TUserGroup[] = [...state.groups];
    groups[index] = {
        ...action.group,
        audios: (action.group.audios || []).map(a => {
            const prevAudio = prev.audios?.find(p => p.id === a.id);
            if (!prevAudio) return a;
            const merged: TAudio = { ...prevAudio };
            (Object.keys(a) as (keyof TAudio)[]).forEach(key => {
                const value = a[key];
                const isEmpty = value === '' || value === null || value === undefined;
                if (!isEmpty) {
                    (merged as any)[key] = value;
                }
            });
            return merged;
        }),
    };
    return {
        ...state,
        groups
    }
}

const addAudioInGroup = (state: IModelsState, action: IAddAudioInGroup): IModelsState => {
    return {
        ...state,
        groups: state.groups.map(group => {
            if (group.id === action.groupId) {
                group.audios = [action.audio, ...(group.audios || [])];
            }
            return group;
        })
    };
}

const updateAudio = (state: IModelsState, action: IUpdateAudioAction) => {
    return {
        ...state,
        groups: state.groups.map(g => {
            if (g.id !== action.groupId) return g;
            return {
                ...g,
                audios: g.audios.map(a => {
                    if (a.id !== action.audioId) return a;
                    return {
                        ...a,
                        ...action.data
                    };
                }),
            }
        }),
    };
}

const removeAudioFromGroup = (state: IModelsState, action: IRemoveAudioFromGroup) => {
    const groups = state.groups.map(g => {
        if (g.id === action.groupId) {
            const audios: TAudio[] = g.audios.filter(audio => audio.id !== action.audioId)
            return {...g, audios}
        } else {
            return {...g}
        }
    })
    return {
        ...state,
        groups
    }
}
